import { createStyles } from "@mantine/core";

const useWidgetPanelStyles = createStyles((theme) => ({
  widgetCardPanel: {
    margin: "0 0 -20px 0",
  },
}));

export default useWidgetPanelStyles;
